// extracted by mini-css-extract-plugin
export default {"container":"TermsOfService_container__bp3YS"};